export const updateQueryParam = (param: string, value: string) => {
    const url = new URL(window.location.href)
    url.searchParams.set(param, value)
    window.history.pushState(null, '', url)
}

export const getRedirectUrlSearch = () =>
    (location.pathname && location.pathname !== '/') || location.search
        ? '?redirectUrl=' + encodeURIComponent(location.pathname + location.search)
        : ''
